import React, { useEffect, useState } from "react";
import { TextField } from "../../primary";
import styles from "./assign.module.scss";
import { Toggle } from "./toggle";

const SectionBlock = ({ section, sectionIndex, renderQuestion, handleSectionTitle, handleSectionToggle, sectionError, sectionRefs, errors }) => {
    const [sectionTitle, setSectionTitle] = useState(section?.name || "");

    useEffect(() => {
        setSectionTitle(section?.name || "");
      }, [section?.name]);

  return (
    <div key={sectionIndex} className={styles.section_block} ref={(el) => (sectionRefs.current[sectionIndex] = el)}>
      <div className={styles.section_header}>
        <div className="">
          <TextField
            id={`section${sectionIndex}`}
            name={`section${sectionIndex}`}
            classes={{
              column: `${styles.section_heading} pb-2`,
              inputColumn: `p-0 outline`,
              inputClassName: `${styles.section_title} ${section.name ? styles.section_title_foc : ""} ${styles.fontBold}`,
            }}
            type="text"
            errors={errors}
            placeholder={`Enter section title`}
            value={sectionTitle}
            onChange={(e) => setSectionTitle(e.target.value)}
            onBlur={() => handleSectionTitle(sectionTitle, sectionIndex)}
          />
          {sectionError?.[sectionIndex] && (
            <div className="pl-1">
              <span className={`${styles.error_message}`}>{sectionError?.[sectionIndex]}</span>
            </div>
          )}
        </div>
        <Toggle checked={section?.isMandatory === 1} type="section" index={sectionIndex} onChange={handleSectionToggle} />
      </div>

      {section.questions.map((value, i) => renderQuestion(value, i === section.questions.length - 1, i, sectionIndex, section?.isMandatory === 1))}
    </div>
  );
};

export default SectionBlock;
